import { connect } from 'react-redux';
import idx from 'idx';
import { reduxForm } from 'redux-form';
import { bindActionCreators } from 'redux';
import { updateSettings } from 'focus_groups/ducks/view_state';
import Settings from 'focus_groups/components/settings';

export const FOCUS_GROUP_SETTINGS_FORM = 'FOCUS_GROUP_SETTINGS_FORM';

export function validate(values) {
  const errors = {};

  if (!values.name) {
    errors.name = 'Please enter a name for this focus group';
  }

  if (!values.purpose) {
    errors.purpose = 'Please enter a purpose for this focus group';
  }

  return errors;
}

export function mapStateToProps(state) {
  const { currentGroup } = idx(state, _ => _.project.focusGroups.viewState) || {};

  return {
    initialValues: { ...currentGroup },
    participants: currentGroup.participants || []
  };
}

export function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    onSubmit: updateSettings,
  }, dispatch);
}

const SettingsForm = reduxForm({
  form: FOCUS_GROUP_SETTINGS_FORM,
  validate,
})(Settings);

export default connect(mapStateToProps, mapDispatchToProps)(SettingsForm);



// WEBPACK FOOTER //
// ./focus_groups/containers/settings.js